import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { FilterKey } from "@studyportals/search-filters";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class Continent extends SeoHeadingHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const singleContinentSelected = await this.singleSelectionFor(FilterKey.CONTINENT, filterSelectionState);
		const continentSelected = await this.selectionOnlyFor([FilterKey.CONTINENT], filterSelectionState);

		return metaRankingSortSelected && singleContinentSelected && continentSelected;
	}

	protected selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const continent = this.getFilterOptionNameBy(FilterKey.CONTINENT, filterSelectionState);
		const year = this.getCurrentYearForSeo();

		const seoInfo = `Best universities in ${continent} ${year} | Studyportals University Meta Ranking`;

		return Promise.resolve(seoInfo);
	}
}
